import Vue from 'vue'
import VueRouter from 'vue-router'
import config from './config'
import store from '../store'
import { webchatAuth } from '@/services/weixin'

//注册路由插件
Vue.use(VueRouter)

//创建路由实例
const router = new VueRouter(config)

//添加路由前置守卫
// webchatAuth();
router.beforeEach((to, from, next) => {
  console.log(to, from, 9999)
  // const userInfo = store.state.user.userInfo;
  // next();
  // console.log(to,from,1111)

  const userInfo = store.state.user.userInfo
  if (
    (userInfo && userInfo.accessToken) ||
    to.name == 'login' ||
    to.name == 'entry'
  ) {
    next()
  } else {
    let tempauthh = 'http://wx.abcvote.cn/actives/courses/home'
    if (window.location.protocol === 'https:') {
      tempauthh = 'https://wx.abcvote.cn/actives/courses/home'
    }
    webchatAuth(tempauthh)
  }
})

router.afterEach((to, from) => {
  if (to.meta.forbidShare) {
    //禁止微信分享
    function onBridgeReady() {
      WeixinJSBridge.call('hideOptionMenu')
    }
    if (typeof WeixinJSBridge == 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
      }
    } else {
      onBridgeReady()
    }
  }
})

//导出路由实例
export default router
